const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Escolha um plano certo com preço simples e transparente",
  monthlyUppercase: "Mensal",
  montly: "Mensal",
  free: "GRATUITO",
  yearlyUppercase: "Anual",
  yearly: "Anual",
  inService: "Em Serviço",
  buyBtn: "Comprar agora",
  freeTips1: "Suporta tamanho máximo de arquivo de 20MB",
  freeTips2: "6 arquivos por dia",
  freeTips3: "Velocidade normal de processamento",
  freeTips4: "Velocidade normal de baixar",
  freeTips5: "Remover fundo de 1 foto por dia",
  freeTips6: "Acesso a todas as ferramentas gratuitas",
  vipTips1: "Tamanho de arquivo ilimitado",
  vipTips2: "Arquivos ilimitados por dia",
  vipTips3: "Velocidade de baixar aumentada 10 vezes mais rápido",
  vipTips4: "Velocidade de processamento aumentada 10 vezes mais rápido",
  vipTips5: "Ilimitada",
  vipTips6: "Remover fundo de imagem sem limites",
  vipTips7: "Acesso a todas as ferramentas e recursos premium",
  vipTips8: "Renovar automaticamente e cancelar a qualquer momento.",
  vipTips9: "Sem limites de tamanho e quantidade de vídeo",
  vipTips10: "Remover fundo de imagem sem limites",
  vipTips11: "Processamento de vídeo e velocidade de download 10X mais rápido",
  vipTips12: "Acesso a todas as ferramentas gratuitas e recursos especiais",
  acceptTitle: "Aceitamos",
  modalTitle: "Atualizar para Pro para acessar todos os recursos premium",
  total: "Total",
  enterCode: "Digitar o código",
  SignUpToPurchaseBtn: "Registrar-se para comprar",
  purchaseBtn: "Ir para comprar",
  saveTips: "Economizar até {{num}}%.",
  discount: "Desconto",
  purchaseTips: "Renovar automaticamente e cancelar a qualquer momento.",
  tips: "Dicas",
  promoCodeInvalidTips: "Seu código de promoção é inválido",
};

export default purchase;
